import React from "react";
import "./Removebg.css";
import arrow from "../assets/images/arrow.png";
import { useRef} from "react";
export default function Removebg({ imgOrigin, imgRmBg }) {
  const imgBox = useRef();
  const imgWarp = useRef();
  const originImg = useRef();
  const line = useRef();
  setTimeout(() => {
    if (document.readyState === "complete") {
      // The page is fully loaded
      let leftSpace = imgBox.current.offsetLeft;
      originImg.current.style.width = imgBox.current.offsetWidth + "px";
      imgBox.current.onmousemove = function (e) {
        let boxWidth = e.pageX - leftSpace + "px";
        imgWarp.current.style.width = boxWidth;
        line.current.style.left = boxWidth;
      };
    }
  }, 1000);

  return (
    <div className="img-container">
      <div className="img-box"  ref={imgBox}>
        <img src={imgRmBg} alt="#" width="100%" />
        <div className="img-wrap" ref={imgWarp}>
          <img src={imgOrigin} alt="#" id="originImg" ref={originImg} />
        </div>
        <span id="line" ref={line}>
          <img src={arrow} alt="#" className="img-arr" />
        </span>
      </div>
    </div>
  );
}
